<template>
  <div :class="['status', { [type]: type }]">{{ status.name || "" }}</div>
</template>

<script>
export default {
  props: {
    status: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    type() {
      if (this.status.id) {
        switch (this.status.id) {
          case 2:
            return "success";
          case 5:
            return "success";
          case 3:
            return "danger";
          case 4:
            return "warn";
          case 1:
            return "normal";
          case 6:
          case 8:
          case 9:
            return "return";
          default:
            return "draft";
        }
      }
      return "";
    },
  },
};
</script>

<style scoped lang="scss">
.status {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  padding: 0 8px;
  height: 24px;
  color: white;
  font-weight: bold;
  font-size: 12px;
  // max-width: 100px;
  white-space: nowrap;
}

.success {
  background: $light-green;
  // width: 96px;
}

.danger {
  background: $red;
  // width: 80px;
}

.warn {
  background: $orange;
  // width: 77px;
}

.normal {
  background: $blue;
  // width: 60px;
}

.draft {
  background: $light-gray;
  color: $light-black;
  // width: 80px;
}

.return {
  background: $orange;
}
</style>
